import type { StateCreator } from "zustand";

import { SubscriptionStatus } from "../enums";
import { Subscription } from "../types";

import { ZSubscription } from "./types";

export const subscriptionSlice: StateCreator<ZSubscription> = (set, get) => {
  return {
    isLoading: true,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),

    subscription: {
      status: SubscriptionStatus.NONE,
    },
    setSubscription: (subscription: Partial<Subscription> | null) =>
      set({ subscription }),
  };
};
